var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.812,
    height: 14.373,
    viewBox: "0 0 14.812 14.373",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "User_profile",
    "data-name": "User profile",
    transform: "translate(-99.556 -946.819)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "person_FILL0_wght400_GRAD0_opsz48",
    d: "M15.406,15.893a3.33,3.33,0,0,1-3.472-3.472A3.33,3.33,0,0,1,15.406,8.95a3.33,3.33,0,0,1,3.472,3.472,3.33,3.33,0,0,1-3.472,3.472ZM8,23.323V21.147a2.547,2.547,0,0,1,.44-1.5,2.823,2.823,0,0,1,1.134-.949,17.4,17.4,0,0,1,2.974-1.042,12.022,12.022,0,0,1,2.858-.347,11.517,11.517,0,0,1,2.847.359,19.716,19.716,0,0,1,2.962,1.03,2.79,2.79,0,0,1,1.157.949,2.547,2.547,0,0,1,.44,1.5v2.176Zm1.389-1.389H21.424v-.787a1.268,1.268,0,0,0-.22-.706,1.393,1.393,0,0,0-.544-.5,12.29,12.29,0,0,0-2.708-.984,11.974,11.974,0,0,0-2.546-.266,12.3,12.3,0,0,0-2.569.266,11.755,11.755,0,0,0-2.708.984,1.393,1.393,0,0,0-.741,1.2ZM15.406,14.5a2.019,2.019,0,0,0,2.083-2.083,2.083,2.083,0,1,0-4.166,0A2.019,2.019,0,0,0,15.406,14.5ZM15.406,12.422ZM15.406,21.934Z",
    transform: "translate(91.556 937.869)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfile);
export default __webpack_public_path__ + "static/media/user_profile.a51af04e2ed696f614253efc6b35eee5.svg";
export { ForwardRef as ReactComponent };